import {createRouter, createWebHistory} from 'vue-router';
import {ROUTE_NAMES} from "@/shared/constants/routeNames.ts";
import {useAuthStore} from "@/stores/useAuthStore.ts";
import {requirePermissionsModule} from '@/router/auth.guards.ts';

import Layout from '@/layouts/Layout.vue';

const routes = [
    {path: '', redirect: ROUTE_NAMES.LOGIN.path},
    {
        path: ROUTE_NAMES.LOGIN.path,
        name: ROUTE_NAMES.LOGIN.name,
        component: () => import('@/views/LoginView.vue')
    },
    {
        path: ROUTE_NAMES.RECOVER_PASSWORD.path,
        name: ROUTE_NAMES.RECOVER_PASSWORD.name,
        component: () => import('@/views/common/RecoverPasswordView.vue')
    },
    {
        path: ROUTE_NAMES.UNAUTHORIZED.path,
        name: ROUTE_NAMES.UNAUTHORIZED.name,
        component: () => import('@/views/common/UnauthorizedView.vue')
    },
    // Layout con rutas protegidas y no protegidas
    {
        path: '/',
        component: Layout,
        meta: {
            requiredAuth: true,
        },

        children: [
            // Cambio de contraseña
            {
                path: ROUTE_NAMES.CHANGE_PASSWORD.path,
                name: ROUTE_NAMES.CHANGE_PASSWORD.name,
                component: () => import('@/views/common/ChangePasswordView.vue')
            },
            // Welcome
            {
                path: ROUTE_NAMES.WELCOME.path,
                redirect: `${ROUTE_NAMES.WELCOME.path}/${ROUTE_NAMES.WELCOME.HOME.path}`,
                meta: { requiredAuth: true},
                children: [
                    {
                        path: ROUTE_NAMES.WELCOME.HOME.path,
                        name: ROUTE_NAMES.WELCOME.HOME.name,
                        component: () => import('@/views/common/WelcomeView.vue')
                    }
                ]
            },
            // Administration
            {
                path: ROUTE_NAMES.ADMINISTRATION.path,
                redirect: `${ROUTE_NAMES.ADMINISTRATION.path}/${ROUTE_NAMES.ADMINISTRATION.USERS.path}`,
                children: [
                    {
                        path: ROUTE_NAMES.ADMINISTRATION.USERS.path,
                        name: ROUTE_NAMES.ADMINISTRATION.USERS.name,
                        meta: {permissions: ['usuarios']},
                        component: () => import('@/views/administration/UsersView.vue'),
                    },
                    {
                        path: ROUTE_NAMES.ADMINISTRATION.MODULES.path,
                        name: ROUTE_NAMES.ADMINISTRATION.MODULES.name,
                        meta: {permissions: ['modulos']},
                        component: () => import('@/views/administration/ModulesView.vue')
                    }
                ]
            },
            // Masters
            {
                path: ROUTE_NAMES.MASTERS.path,
                redirect: `${ROUTE_NAMES.MASTERS.path}/${ROUTE_NAMES.MASTERS.WAREHOUSE.path}`,
                children: [
                    {
                        path: ROUTE_NAMES.MASTERS.WAREHOUSE.path,
                        name: ROUTE_NAMES.MASTERS.WAREHOUSE.name,
                        meta: {permissions: ['bodegas']},
                        component: () => import('@/views/masters/WarehouseView.vue')
                    },
                    {
                        path: ROUTE_NAMES.MASTERS.UNITS.path,
                        name: ROUTE_NAMES.MASTERS.UNITS.name,
                        meta: {permissions: ['unidad']},
                        component: () => import('@/views/masters/UnitView.vue')
                    },
                    {
                        path: ROUTE_NAMES.MASTERS.RUBRO.path,
                        name: ROUTE_NAMES.MASTERS.RUBRO.name,
                        meta: {permissions: ['rubros']},
                        component: () => import('@/views/masters/RubroView.vue')
                    },
                    {
                        path: `${ROUTE_NAMES.MASTERS.FORMULAS.path}`,
                        meta: {permissions: ['formulas']},
                        children: [
                            {
                                path: '',
                                name: ROUTE_NAMES.MASTERS.FORMULAS.name,
                                component: () => import('@/views/masters/FormulasView.vue')
                            },
                            {
                                path: ROUTE_NAMES.MASTERS.FORMULAS.COMPONENTES.path,
                                name: ROUTE_NAMES.MASTERS.FORMULAS.COMPONENTES.name,
                                component: () => import('@/views/masters/ComponentsView.vue')
                            }
                        ]
                    },
                    {
                        path: ROUTE_NAMES.MASTERS.MOTIVOS.path,
                        name: ROUTE_NAMES.MASTERS.MOTIVOS.name,
                        meta: {permissions: ['motivos']},
                        component: () => import('@/views/masters/MotivosView.vue')
                    },
                    {
                        path: `${ROUTE_NAMES.MASTERS.ARTICLES.path}`,
                        meta: {permissions: ['articulos']},
                        children: [
                            {
                                path: '',
                                name: ROUTE_NAMES.MASTERS.ARTICLES.name,

                                component: () => import('@/views/masters/ArticlesView.vue')
                            },
                            {
                                path: ROUTE_NAMES.MASTERS.ARTICLES.FORMS.path,
                                name: ROUTE_NAMES.MASTERS.ARTICLES.FORMS.name,
                                component: () => import('@/views/masters/SaveArticleView.vue')
                            },
                            {
                                path: ROUTE_NAMES.MASTERS.ARTICLES.UPDATE.path,
                                name: ROUTE_NAMES.MASTERS.ARTICLES.UPDATE.name,
                                component: () => import('@/views/masters/SaveArticleView.vue')
                            },
                        ]
                    }
                ]
            },
            // Process
            {
                path: ROUTE_NAMES.PROCESS.path,
                redirect: `${ROUTE_NAMES.PROCESS.path}/${ROUTE_NAMES.PROCESS.MATERIAPRIMA.path}`,
                children: [
                    {
                        path: ROUTE_NAMES.PROCESS.MATERIAPRIMA.path,
                        meta: {permissions: ['materiap']},
                        children: [
                            {
                                path: '',
                                name: ROUTE_NAMES.PROCESS.MATERIAPRIMA.name,
                                component: () => import('@/views/process/rawmaterial/StockView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.MATERIAPRIMA.FORMS.path,
                                name: ROUTE_NAMES.PROCESS.MATERIAPRIMA.FORMS.name,
                                component: () => import('@/views/process/rawmaterial/InStockHeaderView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.MATERIAPRIMA.UPDATE.path,
                                name: ROUTE_NAMES.PROCESS.MATERIAPRIMA.UPDATE.name,
                                component: () => import('@/views/process/rawmaterial/InStockHeaderView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.MATERIAPRIMA.UPDATEMATERIA.path,
                                name: ROUTE_NAMES.PROCESS.MATERIAPRIMA.UPDATEMATERIA.name,
                                component: () => import('@/views/process/rawmaterial/OutStockHeaderView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.MATERIAPRIMA.PRODUCTS.path,
                                name: ROUTE_NAMES.PROCESS.MATERIAPRIMA.PRODUCTS.name,
                                component: () => import('@/views/process/rawmaterial/InStockDetailView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.MATERIAPRIMA.SALIDA.path,
                                name: ROUTE_NAMES.PROCESS.MATERIAPRIMA.SALIDA.name,
                                component: () => import('@/views/process/rawmaterial/OutStockHeaderView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.MATERIAPRIMA.OUTPRODUCTS.path,
                                name: ROUTE_NAMES.PROCESS.MATERIAPRIMA.OUTPRODUCTS.name,
                                component: () => import('@/views/process/rawmaterial/OutStockDetailView.vue')
                            },

                        ]
                    },
                    {
                        path: ROUTE_NAMES.PROCESS.MATERIALEMPAQUE.path,
                        meta: {permissions: ['materiale']},
                        children: [
                            {
                                path: '',
                                name: ROUTE_NAMES.PROCESS.MATERIALEMPAQUE.name,
                                component: () => import('@/views/process/packagingMaterial/StockView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.MATERIALEMPAQUE.FORMS.path,
                                name: ROUTE_NAMES.PROCESS.MATERIALEMPAQUE.FORMS.name,
                                component: () => import('@/views/process/packagingMaterial/InStockHeaderView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.MATERIALEMPAQUE.UPDATE.path,
                                name: ROUTE_NAMES.PROCESS.MATERIALEMPAQUE.UPDATE.name,
                                component: () => import('@/views/process/packagingMaterial/InStockHeaderView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.MATERIALEMPAQUE.UPDATEMATERIA.path,
                                name: ROUTE_NAMES.PROCESS.MATERIALEMPAQUE.UPDATEMATERIA.name,
                                component: () => import('@/views/process/packagingMaterial/OutStockHeaderView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.MATERIALEMPAQUE.PRODUCTS.path,
                                name: ROUTE_NAMES.PROCESS.MATERIALEMPAQUE.PRODUCTS.name,
                                component: () => import('@/views/process/packagingMaterial/InStockDetailView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.MATERIALEMPAQUE.SALIDA.path,
                                name: ROUTE_NAMES.PROCESS.MATERIALEMPAQUE.SALIDA.name,
                                component: () => import('@/views/process/packagingMaterial/OutStockHeaderView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.MATERIALEMPAQUE.OUTPRODUCTS.path,
                                name: ROUTE_NAMES.PROCESS.MATERIALEMPAQUE.OUTPRODUCTS.name,
                                component: () => import('@/views/process/packagingMaterial/OutStockDetailView.vue')
                            },
                        ]
                    },
                    {
                        path: ROUTE_NAMES.PROCESS.MIXTURE.path,
                        meta: {permissions: ['mezclas']},
                        children: [
                            {
                                path: '',
                                name: ROUTE_NAMES.PROCESS.MIXTURE.name,
                                component: () => import('@/views/process/mixtures/MixturesView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.MIXTURE.INHEADER.path,
                                name: ROUTE_NAMES.PROCESS.MIXTURE.INHEADER.name,
                                component: () => import('@/views/process/mixtures/InHeaderMixtureView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.MIXTURE.INHEADERUPDATE.path,
                                name: ROUTE_NAMES.PROCESS.MIXTURE.INHEADERUPDATE.name,
                                component: () => import('@/views/process/mixtures/InHeaderMixtureView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.MIXTURE.INDETAIL.path,
                                name: ROUTE_NAMES.PROCESS.MIXTURE.INDETAIL.name,
                                component: () => import('@/views/process/mixtures/InDetailMixtureView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.MIXTURE.OUTHEADER.path,
                                name: ROUTE_NAMES.PROCESS.MIXTURE.OUTHEADER.name,
                                component: () => import('@/views/process/mixtures/OutHeaderMixtureView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.MIXTURE.OUTHEADERUPDATE.path,
                                name: ROUTE_NAMES.PROCESS.MIXTURE.OUTHEADERUPDATE.name,
                                component: () => import('@/views/process/mixtures/OutHeaderMixtureView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.MIXTURE.OUTDETAIL.path,
                                name: ROUTE_NAMES.PROCESS.MIXTURE.OUTDETAIL.name,
                                component: () => import('@/views/process/mixtures/OutDetailMixtureView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.MIXTURE.OUTDYNAMICDETAIL.path,
                                name: ROUTE_NAMES.PROCESS.MIXTURE.OUTDYNAMICDETAIL.name,
                                component: () => import('@/views/process/mixtures/OutDynamicDetailMixtureView.vue')
                            }

                        ]
                    },
                    {
                        path: ROUTE_NAMES.PROCESS.LIQUIDS.path,
                        meta: {permissions: ['mezclasl']},
                        children: [
                            {
                                path: '',
                                name: ROUTE_NAMES.PROCESS.LIQUIDS.name,
                                component: () => import('@/views/process/liquid/LiquidsView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.LIQUIDS.INHEADER.path,
                                name: ROUTE_NAMES.PROCESS.LIQUIDS.INHEADER.name,
                                component: () => import('@/views/process/liquid/InHeaderLiquidView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.LIQUIDS.INHEADERUPDATE.path,
                                name: ROUTE_NAMES.PROCESS.LIQUIDS.INHEADERUPDATE.name,
                                component: () => import('@/views/process/liquid/InHeaderLiquidView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.LIQUIDS.INDETAIL.path,
                                name: ROUTE_NAMES.PROCESS.LIQUIDS.INDETAIL.name,
                                component: () => import('@/views/process/liquid/InDetailLiquidView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.LIQUIDS.OUTHEADER.path,
                                name: ROUTE_NAMES.PROCESS.LIQUIDS.OUTHEADER.name,
                                component: () => import('@/views/process/liquid/OutHeaderLiquidView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.LIQUIDS.OUTHEADERUPDATE.path,
                                name: ROUTE_NAMES.PROCESS.LIQUIDS.OUTHEADERUPDATE.name,
                                component: () => import('@/views/process/liquid/OutHeaderLiquidView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.LIQUIDS.OUTDETAIL.path,
                                name: ROUTE_NAMES.PROCESS.LIQUIDS.OUTDETAIL.name,
                                component: () => import('@/views/process/liquid/OutDetailLiquidView.vue')
                            }
                        ]
                    },
                    {
                        path: ROUTE_NAMES.PROCESS.PACKAGING.path, meta: {permissions: ['sachetado']}, children: [
                            {
                                path: '',
                                name: ROUTE_NAMES.PROCESS.PACKAGING.name,
                                component: () => import('@/views/process/packaging/PackagingView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.PACKAGING.INHEADER.path,
                                name: ROUTE_NAMES.PROCESS.PACKAGING.INHEADER.name,
                                component: () => import('@/views/process/packaging/InHeaderPackagingView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.PACKAGING.OUTHEADER.path,
                                name: ROUTE_NAMES.PROCESS.PACKAGING.OUTHEADER.name,
                                component: () => import('@/views/process/packaging/OutHeaderPackagingView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.PACKAGING.OUTHEADERUPDATE.path,
                                name: ROUTE_NAMES.PROCESS.PACKAGING.OUTHEADERUPDATE.name,
                                component: () => import('@/views/process/packaging/OutHeaderPackagingView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.PACKAGING.INHEADERUPDATE.path,
                                name: ROUTE_NAMES.PROCESS.PACKAGING.INHEADERUPDATE.name,
                                component: () => import('@/views/process/packaging/InHeaderPackagingView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.PACKAGING.INDETAIL.path,
                                name: ROUTE_NAMES.PROCESS.PACKAGING.INDETAIL.name,
                                component: () => import('@/views/process/packaging/InDetailPackagingView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.PACKAGING.OUTDETAIL.path,
                                name: ROUTE_NAMES.PROCESS.PACKAGING.OUTDETAIL.name,
                                component: () => import('@/views/process/packaging/OutDetailPackagingView.vue')
                            }
                        ]
                    },
                    {
                        path: ROUTE_NAMES.PROCESS.PRODUCT_FLOW.path,
                        meta: {permissions: ['empaquetado']},
                        children: [
                            {
                                path: '',
                                name: ROUTE_NAMES.PROCESS.PRODUCT_FLOW.name,
                                component: () => import('@/views/process/productFlow/ProductFlowView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.PRODUCT_FLOW.INHEADER.path,
                                name: ROUTE_NAMES.PROCESS.PRODUCT_FLOW.INHEADER.name,
                                component: () => import('@/views/process/productFlow/InHeaderProductFlowView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.PRODUCT_FLOW.OUTHEADER.path,
                                name: ROUTE_NAMES.PROCESS.PRODUCT_FLOW.OUTHEADER.name,
                                component: () => import('@/views/process/productFlow/OutHeaderProductFlow.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.PRODUCT_FLOW.OUTHEADERUPDATE.path,
                                name: ROUTE_NAMES.PROCESS.PRODUCT_FLOW.OUTHEADERUPDATE.name,
                                component: () => import('@/views/process/productFlow/OutHeaderProductFlow.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.PRODUCT_FLOW.INHEADERUPDATE.path,
                                name: ROUTE_NAMES.PROCESS.PRODUCT_FLOW.INHEADERUPDATE.name,
                                component: () => import('@/views/process/productFlow/InHeaderProductFlowView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.PRODUCT_FLOW.INDETAIL.path,
                                name: ROUTE_NAMES.PROCESS.PRODUCT_FLOW.INDETAIL.name,
                                component: () => import('@/views/process/productFlow/InDetailProductFlowView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.PRODUCT_FLOW.OUTDETAIL.path,
                                name: ROUTE_NAMES.PROCESS.PRODUCT_FLOW.OUTDETAIL.name,
                                component: () => import('@/views/process/productFlow/OutDetailProductFlow.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.PRODUCT_FLOW.OUTDETAILFORMULA.path,
                                name: ROUTE_NAMES.PROCESS.PRODUCT_FLOW.OUTDETAILFORMULA.name,
                                component: () => import('@/views/process/productFlow/OutDynamicDetailProductFlowView.vue')
                            },

                        ]
                    },
                    {
                        path: ROUTE_NAMES.PROCESS.FINAL_PRODUCT.path,
                        meta: {permissions: ['productot']},
                        children: [
                            {
                                path: '',
                                name: ROUTE_NAMES.PROCESS.FINAL_PRODUCT.name,
                                component: () => import('@/views/process/finalProduct/FinalProductView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.FINAL_PRODUCT.INHEADER.path,
                                name: ROUTE_NAMES.PROCESS.FINAL_PRODUCT.INHEADER.name,
                                component: () => import('@/views/process/finalProduct/InHeaderFinalProductView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.FINAL_PRODUCT.OUTHEADER.path,
                                name: ROUTE_NAMES.PROCESS.FINAL_PRODUCT.OUTHEADER.name,
                                component: () => import('@/views/process/finalProduct/OutHeaderFinalProduct.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.FINAL_PRODUCT.OUTHEADERUPDATE.path,
                                name: ROUTE_NAMES.PROCESS.FINAL_PRODUCT.OUTHEADERUPDATE.name,
                                component: () => import('@/views/process/finalProduct/OutHeaderFinalProduct.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.FINAL_PRODUCT.INHEADERUPDATE.path,
                                name: ROUTE_NAMES.PROCESS.FINAL_PRODUCT.INHEADERUPDATE.name,
                                component: () => import('@/views/process/finalProduct/InHeaderFinalProductView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.FINAL_PRODUCT.INDETAIL.path,
                                name: ROUTE_NAMES.PROCESS.FINAL_PRODUCT.INDETAIL.name,
                                component: () => import('@/views/process/finalProduct/InDetailFinalProductView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.FINAL_PRODUCT.OUTDETAIL.path,
                                name: ROUTE_NAMES.PROCESS.FINAL_PRODUCT.OUTDETAIL.name,
                                component: () => import('@/views/process/finalProduct/OutDetailFinalProduct.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.FINAL_PRODUCT.OUTDETAILFORMULA.path,
                                name: ROUTE_NAMES.PROCESS.FINAL_PRODUCT.OUTDETAILFORMULA.name,
                                component: () => import('@/views/process/finalProduct/OutDynamicDetailFinalProduct.vue')
                            },
                        ]
                    },
                    {
                        path: ROUTE_NAMES.PROCESS.QUALITY.path,
                        meta: {permissions: ['calidad']},
                        children: [
                            {
                                path: '',
                                name: ROUTE_NAMES.PROCESS.QUALITY.name,
                                component: () => import('@/views/process/qualityControl/StockView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.QUALITY.FORMS.path,
                                name: ROUTE_NAMES.PROCESS.QUALITY.FORMS.name,
                                component: () => import('@/views/process/qualityControl/InStockHeaderView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.QUALITY.UPDATE.path,
                                name: ROUTE_NAMES.PROCESS.QUALITY.UPDATE.name,
                                component: () => import('@/views/process/qualityControl/InStockHeaderView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.QUALITY.UPDATEMATERIA.path,
                                name: ROUTE_NAMES.PROCESS.QUALITY.UPDATEMATERIA.name,
                                component: () => import('@/views/process/qualityControl/OutStockHeaderView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.QUALITY.PRODUCTS.path,
                                name: ROUTE_NAMES.PROCESS.QUALITY.PRODUCTS.name,
                                component: () => import('@/views/process/qualityControl/InStockDetailView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.QUALITY.SALIDA.path,
                                name: ROUTE_NAMES.PROCESS.QUALITY.SALIDA.name,
                                component: () => import('@/views/process/qualityControl/OutStockHeaderView.vue')
                            },
                            {
                                path: ROUTE_NAMES.PROCESS.QUALITY.OUTPRODUCTS.path,
                                name: ROUTE_NAMES.PROCESS.QUALITY.OUTPRODUCTS.name,
                                component: () => import('@/views/process/qualityControl/OutStockDetailView.vue')
                            },
                        ]
                    }
                ]
            },
           // Reports
            {
              path: ROUTE_NAMES.REPORTS.path,
              meta: {permissions: ['reportes']},
              children: [
                {
                  path: '',
                  name: ROUTE_NAMES.REPORTS.name,
                  component: () => import('@/views/reports/DashboardView.vue')
                }
                ]
            }
        ]
    },
    {
        path: ROUTE_NAMES.NOT_FOUND.path,
        name: ROUTE_NAMES.NOT_FOUND.name,
        component: () => import('@/views/common/NoFoundView.vue')
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, _from, savedPosition) {
        if (to.hash) {
            return {el: to.hash};
        }
        if (savedPosition) return savedPosition;
        return {top: 0};
    }
});

import {isLoading} from '@/shared/composables/loading.ts'

router.beforeEach((to, from, next) => {
        isLoading.value = true;
    const authStore = useAuthStore();
    const isAuthenticated = !!authStore.accessToken;

    if (to.name === ROUTE_NAMES.LOGIN.name && isAuthenticated) {
        return next({name: ROUTE_NAMES.WELCOME.HOME.name});
    } else if (isAuthenticated) {
        const routeWithPermissions = to.matched.find(record => record.meta && record.meta['permissions']);
        if (routeWithPermissions) {
            const permissions: string[] = routeWithPermissions.meta['permissions'] as string[];
            return requirePermissionsModule(to, from, next, authStore, permissions);
        } else {
            return next();
        }
    } else if ( !to.matched.some(record => record.meta.requiredAuth)) {
        return next();
    } else {
        return next({ name: ROUTE_NAMES.LOGIN.name });
    }
});


router.afterEach(() => {
    isLoading.value = false;
});

export default router;
